// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gt-a";
export var fulfillmentFormRail = "_gt-9";
export var headerTitleRow = "_gt-c";
export var orderDetailsWrapper = "_gt-7";
export var orderLinkTrigger = "_gt-2";
export var paymentInformationGrid = "_gt-h";
export var paymentSummaryColumn = "_gt-i";
export var shipmentContainer = "_gt-b";
export var shipmentDetailsMainPane = "_gt-8";
export var shipmentNavigationCard = "_gt-5";
export var shipmentNavigationRail = "_gt-3";
export var shipmentNavigationRailHeader = "_gt-4";
export var shipmentSummaryFact = "_gt-e";
export var shipmentSummaryGrid = "_gt-d";
export var shipmentSummaryMetadataRow = "_gt-f";
export var shipmentSummaryTags = "_gt-g";
export var shipmentWorkspace = "_gt-0";
export var shipmentWorkspaceContent = "_gt-6";
export var shipmentWorkspaceHeader = "_gt-1";